<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
        <div class="modal-container">
            <p> Le ou les charts suivants posent problème:</p>
             <ul>
              <li v-for="error in this.$store.state.stackedErrors" v-bind:key="error">
                  {{error}}    
              </li>
            </ul>
            <p> Le nombre de données dans chaque tableau de chart_value ne correspond pas au nombre d'étiquettes renseigné dans "chart_text".</p>
            <div class="modal-footer">
            <slot name="footer">
                <button class="modal-default-button" @click="close()">
                OK
                </button>
            </slot>
            </div>
        </div>
        </div>
    </div>
</template>

<script>

export default {
    name:'stackedErrorModal',
    data(){
      return {

      }
    },
    created(){

      //console.log("comp", this.$store.state.showMismatchModal)

    },
    methods:{
        close(){
              this.$store.commit('HIDE_STACKED_ERROR_MODAL')

        }
    }
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  height: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>